// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import zappy from '@zappy-ride/library.react.components';
import { useCalculationSelectors } from '../../../../selectors/calculations';

export const OutputEmissions = ({ design }: { design: string }) => {
  const { schema } = zappy.useDesign(design);
  const [{ data: emissionsData, status }] = useCalculationSelectors('emissionsTable');
  const data = { ...emissionsData };
  if (status.isLoading) return 'Loading';

  if (status.missingRequiredInformation)
    return 'Missing required info for calculations';

  return (
    <zappy.FactoryComponent schema={schema} data-design={design}>
      <zappy.ContentContainer design={design} values={data || {}} />
    </zappy.FactoryComponent>
  );
};

OutputEmissions.displayName = 'OutputEmissions';
